import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var SlackIcon = function SlackIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#788590' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M6.216 14.643a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 2.1-2.102h2.1v2.102Zm1.05 0a2.1 2.1 0 1 1 4.2 0v5.255a2.099 2.099 0 1 1-4.2 0v-5.255ZM9.367 6.204a2.1 2.1 0 0 1-2.1-2.102 2.1 2.1 0 1 1 4.2 0v2.102h-2.1Zm0 1.067a2.1 2.1 0 0 1 2.1 2.102 2.1 2.1 0 0 1-2.1 2.102H4.1A2.1 2.1 0 0 1 2 9.373 2.1 2.1 0 0 1 4.1 7.27h5.267ZM17.784 9.373a2.099 2.099 0 1 1 4.2 0 2.099 2.099 0 0 1-2.1 2.102h-2.1V9.373Zm-1.05 0a2.099 2.099 0 1 1-4.201 0V4.102a2.099 2.099 0 1 1 4.2 0v5.27ZM14.633 17.796c1.162 0 2.1.94 2.1 2.102a2.099 2.099 0 1 1-4.2 0v-2.102h2.1Zm0-1.05c-1.161 0-2.1-.94-2.1-2.103 0-1.162.939-2.102 2.1-2.102H19.9c1.161 0 2.1.94 2.1 2.102a2.099 2.099 0 0 1-2.1 2.102h-5.267Z"
  }));
};
export default SlackIcon;